export function setMessage(store, data) {
    store.commit("MESSAGE", data);
}
export function resetMessages(store) {
    store.commit("MESSAGE", null);
}
export default {
    setMessage,
    resetMessages,
};
